import { render, staticRenderFns } from "./ObservationStatusButtons.vue?vue&type=template&id=269c1f60&"
import script from "./ObservationStatusButtons.vue?vue&type=script&lang=js&"
export * from "./ObservationStatusButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports